// extracted by mini-css-extract-plugin
export var card = "_on-0";
export var content = "_on-2";
export var details = "_on-3";
export var icon = "_on-1";
export var iconBlue = "_on-5";
export var iconBrand = "_on-4";
export var iconGrayBlue = "_on-6";
export var iconGreen = "_on-7";
export var iconIndigo = "_on-8";
export var iconOrange = "_on-9";
export var iconPurple = "_on-a";
export var iconRed = "_on-b";
export var iconWarning = "_on-c";